import { detectDomain, Domain } from '@/routing/helpers/subdomain-helper';
import { DataProcessingService } from '@/libraries/usercentrics/types';
import { TrackingProvider } from './tracking-provider';

interface MarfeelCompass {
	trackNewPage: (options?: { url?: string; rs?: string; initialPageVars?: Record<string, any> }) => void;
}

type MarfeelWindow = Window &
	typeof globalThis & {
		marfeel: {
			cmd: Array<[string, (compass: MarfeelCompass) => void]>;
			config?: {
				accountId?: string;
				[key: string]: any;
			};
		};
	};

export class TrackingProviderMarfeel extends TrackingProvider {
	dataProcessingService = DataProcessingService.MARFEEL;

	constructor(private config: { id: string; doNotTrack: boolean }) {
		super();
	}

	initialize(): Promise<void> {
		return new Promise((resolve, reject) => {
			if (this.config.doNotTrack || typeof window === 'undefined') {
				resolve();
				return;
			}

			const currentDomain = detectDomain(window.location.hostname);
			if (currentDomain !== Domain.EDITORIAL) {
				return resolve();
			}

			function injectScript(src: string, isModule: boolean): Promise<void> {
				return new Promise((resolveScript, rejectScript) => {
					const script = document.createElement('script');
					script.src = src;

					if (isModule) {
						script.type = 'module';
					} else {
						script.async = true;
						script.type = 'text/javascript';
						script.setAttribute('nomodule', '');
					}

					script.onload = () => resolveScript();
					script.onerror = () => rejectScript(new Error(`Failed to load ${src}`));

					const firstScript = document.getElementsByTagName('script')[0];
					firstScript.parentNode?.insertBefore(script, firstScript);
				});
			}

			async function load(window: any, id: string, userConfig: any) {
				window.marfeel = window.marfeel || {};
				window.marfeel.cmd = window.marfeel.cmd || [];
				window.marfeel.config = userConfig;
				window.marfeel.config.accountId = id;

				const resourcesPath = 'https://sdk.mrf.io/statics';

				try {
					// Load both scripts
					await Promise.all([
						injectScript(`${resourcesPath}/marfeel-sdk.js?id=${id}`, true),
						injectScript(`${resourcesPath}/marfeel-sdk.es5.js?id=${id}`, false),
					]);
					resolve();
				} catch (error) {
					reject(error);
				}
			}

			load(window, this.config.id, {});
		});
	}
	async trackPage() {
		(window as MarfeelWindow).marfeel = (window as MarfeelWindow).marfeel || { cmd: [] };
		(window as MarfeelWindow).marfeel.cmd.push([
			'compass',
			function (compass: MarfeelCompass) {
				compass.trackNewPage();
			},
		]);
	}

	refreshPermanentAudiences(_permanent_audiences: string[] = []) {}
	refreshPermanentAudiencesSubgenres(_permanent_audiences: string[] = []) {}

	async trackEvent() {}
}
